module.exports = __webpack_public_path__ + "static/media/NotoSans-SemiBold.65a6d6e5.eot";